export default "__VITE_ASSET__BHZrAf2i__"